function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
/* This is a 'physical' class that is mapped to
 * the user table. We can have methods on it that
 * we could call on retrieved database objects.
 */ export class Member {
    constructor(user){
        _define_property(this, "firstName", void 0);
        _define_property(this, "lastName", void 0);
        _define_property(this, "emailId", void 0);
        _define_property(this, "userId", void 0);
        _define_property(this, "photoUrl", void 0);
        _define_property(this, "userType", void 0);
        _define_property(this, "company", void 0);
        _define_property(this, "role", void 0);
        _define_property(this, "userStatus", void 0);
        _define_property(this, "timeZone", void 0);
        _define_property(this, "fields", void 0);
        _define_property(this, "defaultCapacity", void 0);
        _define_property(this, "capacityMinutes", void 0);
        _define_property(this, "projectIds", void 0);
        _define_property(this, "userTimeOffDetails", void 0);
        _define_property(this, "userGroups", void 0);
        _define_property(this, "holidayCalendarId", void 0);
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.emailId = user.emailId;
        this.userId = user.userId;
        this.photoUrl = user.photoUrl;
        this.userType = user.userType;
        this.company = user.company;
        this.role = user.role;
        this.userStatus = user.userStatus;
        this.timeZone = user.timeZone;
        this.fields = user.fields;
        this.defaultCapacity = user.defaultCapacity;
        this.capacityMinutes = user.capacityMinutes;
        this.userTimeOffDetails = user === null || user === void 0 ? void 0 : user.userTimeOffDetails;
        this.userGroups = user.userGroups;
        this.holidayCalendarId = user === null || user === void 0 ? void 0 : user.holidayCalendarId;
    }
}
